import styled, { css } from 'styled-components';
import { Input } from 'antd';

interface IErrors {
    error?: string;
}

export const StyledInput = styled(Input.TextArea)<IErrors>`
    && {
        ${({ theme, error }) => css`
            font-size: ${theme.fontSizes.default};
            height: 16rem;
            border-radius: 8px;
            color: ${theme.colors.font};
            resize: none;

            &:hover,
            &:focus {
                ${!error &&
                css`
                    border-color: ${theme.colors.accentColor};
                `};
            }

            ${error &&
            css`
                border-color: ${theme.colors.fail};
            `};
        `};
    }
`;

export const Title = styled.p`
    ${({ theme }) => css`
        color: ${theme.colors.font};
        font-size: ${theme.fontSizes.little};
        margin-bottom: 0.5rem;
    `}
`;
